import http from "./http";

class API {
  register(params: Record<string, unknown>) {
    return http.post("/api/register", { ...params, source_url: window.location.href });
  }

  unfollowTag(tagId: string) {
    return http.delete(`/api/tags/${tagId}/follow`);
  }

  logEvent(eventName: string, eventData: string | null) {
    return http.post("/api/event", { event_name: eventName, event_data: eventData });
  }

  articleLinkClick(articleId: string, url: string) {
    return http.put(`/api/articles/${articleId}/link-clicked`, { url });
  }
}

export default new API();
